import embla from 'embla-carousel';
import autoplay from 'embla-carousel-autoplay';

class HomeHero {
  constructor() {
    const sections = document.querySelectorAll('.home-hero');

    sections.forEach(section => {
      const root = section.querySelector('.home-hero__slider');
      const prev = section.querySelector('.home-hero__button--prev');
      const next = section.querySelector('.home-hero__button--next');
      const dots = section.querySelectorAll('.home-hero__dot');
      const items = section.querySelectorAll('.home-hero-item');

      const options = {
        loop: true,
        watchDrag: items.length > 1 ? true : false,
      };

      const plugins = [
        autoplay({
          delay: 7000,
          stopOnMouseEnter: true,
        })
      ];

      const carousel = embla(root, options, plugins);

      const selectDot = () => {
        const previous = carousel.previousScrollSnap();
        const selected = carousel.selectedScrollSnap();

        dots[previous]?.classList.remove('home-hero__dot--active');
        dots[selected]?.classList.add('home-hero__dot--active');
      }

      carousel.on('init', selectDot);
      carousel.on('select', selectDot);

      dots.forEach((dot, id) => {
        dot.addEventListener('click', () => carousel.scrollTo(id));
      });

      prev?.addEventListener('click', carousel.scrollPrev);
      next?.addEventListener('click', carousel.scrollNext);
    });
  }
}

export default HomeHero;
